// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=DM+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* URL Lists Page - Distinctive Design for Sense Platform */

/* Import fonts */

/* Layout */
.url-lists-layout {
  display: grid;
  grid-template-columns: 340px minmax(0, 1fr);
  gap: 0;
  min-height: calc(100vh - 140px);
  background: transparent;
}

/* A grid item defaults to min-width:auto, so it refuses to shrink below its
   content and pushes the page wider than the screen instead. The research
   dashboard lives in the right panel and is full of wide content — a 36px
   title, a row of buttons, tables — so without this the whole page scrolls
   sideways on a laptop. */
.url-lists-layout > * {
  min-width: 0;
}

/* Left Panel - Lists */
.url-lists-panel {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-right: 1px solid rgba(0, 0, 0, 0.06);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: calc(100vh - 140px);
  position: sticky;
  top: 0;
  overflow: hidden;
}

.panel-section {
  flex-shrink: 0;
}

.panel-section .field-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.panel-section .field-select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  background: #fff;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.panel-section .field-select:hover {
  border-color: rgba(0, 0, 0, 0.2);
}

.panel-section .field-select:focus {
  outline: none;
  border-color: var(--accent-orange);
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

/* Search */
.search-wrapper {
  position: relative;
}

.search-wrapper .search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: var(--text-tertiary);
  pointer-events: none;
}

.search-input {
  width: 100%;
  padding: 11px 14px 11px 42px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  background: #fff;
  color: var(--text-primary);
  transition: all 0.2s ease;
}

.search-input::placeholder {
  color: var(--text-tertiary);
}

.search-input:hover {
  border-color: rgba(0, 0, 0, 0.2);
}

.search-input:focus {
  outline: none;
  border-color: var(--accent-orange);
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

/* Add Button */
.add-list-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 14px 20px;
  border: 2px dashed rgba(255, 107, 74, 0.4);
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.05) 0%, rgba(233, 75, 108, 0.05) 100%);
  color: var(--accent-orange);
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.25s ease;
  flex-shrink: 0;
}

.add-list-btn svg {
  width: 18px;
  height: 18px;
}

.add-list-btn:hover {
  border-color: var(--accent-orange);
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.12) 0%, rgba(233, 75, 108, 0.08) 100%);
  transform: translateY(-1px);
}

.add-list-btn:active {
  transform: translateY(0);
}

/* Lists Container */
.lists-container {
  flex: 1 1;
  overflow-y: auto;
  margin: 0 -24px;
  padding: 0 24px;
}

.lists-container::-webkit-scrollbar {
  width: 6px;
}

.lists-container::-webkit-scrollbar-track {
  background: transparent;
}

.lists-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.lists-container::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.2);
}

/* Loading & Empty States */
.lists-loading,
.lists-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: var(--text-tertiary);
  gap: 12px;
}

.lists-loading .spinner,
.btn-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 107, 74, 0.2);
  border-top-color: var(--accent-orange);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.lists-empty svg {
  width: 48px;
  height: 48px;
  opacity: 0.4;
}


/* List Item */
.list-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  margin-bottom: 6px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.02);
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.list-item:hover {
  background: rgba(255, 107, 74, 0.06);
  border-color: rgba(255, 107, 74, 0.15);
}

.list-item.active {
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.12) 0%, rgba(233, 75, 108, 0.08) 100%);
  border-color: rgba(255, 107, 74, 0.3);
}

.list-item-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.list-item-icon.keyword-icon {
  background: linear-gradient(135deg, var(--accent-red) 0%, var(--accent-purple) 100%);
}

.editor-empty-icon.keyword-icon {
  background: linear-gradient(135deg, rgba(233, 75, 108, 0.08) 0%, rgba(142, 58, 154, 0.08) 100%);
}

.editor-empty-icon.keyword-icon::before {
  background: linear-gradient(135deg, var(--accent-red) 0%, var(--accent-purple) 100%);
}

.editor-empty-icon.keyword-icon svg {
  color: var(--accent-purple);
}

.list-item-icon.geo-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.editor-empty-icon.geo-icon {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(5, 150, 105, 0.08) 100%);
}

.editor-empty-icon.geo-icon::before {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.editor-empty-icon.geo-icon svg {
  color: #059669;
}

.list-item-icon svg {
  width: 18px;
  height: 18px;
  color: white;
}

.list-item-content {
  flex: 1 1;
  min-width: 0;
}

.list-item-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}

.list-item-meta {
  font-size: 12px;
  color: var(--text-secondary);
  font-family: 'Space Mono', monospace;
}

.list-item-arrow {
  width: 18px;
  height: 18px;
  color: var(--text-tertiary);
  flex-shrink: 0;
  opacity: 0;
  transform: translateX(-4px);
  transition: all 0.2s ease;
}

.list-item:hover .list-item-arrow,
.list-item.active .list-item-arrow {
  opacity: 1;
  transform: translateX(0);
}

.list-item.active .list-item-arrow {
  color: var(--accent-orange);
}

/* Right Panel - Editor */
.url-editor-panel {
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px);
  min-height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
}

/* Empty State */
.editor-empty {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  text-align: center;
}

.editor-empty-icon {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.08) 0%, rgba(142, 58, 154, 0.08) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
  position: relative;
}

.editor-empty-icon::before {
  content: '';
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-purple) 100%);
  opacity: 0.15;
  z-index: -1;
}

.editor-empty-icon svg {
  width: 48px;
  height: 48px;
  color: var(--accent-red);
}

.editor-empty h3 {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.editor-empty p {
  font-size: 15px;
  color: var(--text-secondary);
  margin-bottom: 28px;
  max-width: 320px;
}

.editor-empty-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 28px;
  background: var(--accent-gradient);
  color: white;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 20px rgba(255, 107, 74, 0.3);
}

.editor-empty-btn svg {
  width: 18px;
  height: 18px;
}

.editor-empty-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(255, 107, 74, 0.4);
}

/* Editor Content */
.editor-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 32px 40px;
}

.editor-content.geo-editor {
  min-height: 0;
}

.editor-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 24px;
  flex-shrink: 0;
}

.editor-header h2 {
  font-size: 22px;
  font-weight: 600;
  color: var(--text-primary);
}

.editor-locked-badge {
  font-size: 12px;
  font-weight: 600;
  color: #92400e;
  background: #fef3c7;
  border: 1px solid #fde68a;
  padding: 4px 10px;
  border-radius: 999px;
  white-space: nowrap;
}

/* Alerts */
.alert {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-radius: 12px;
  margin-bottom: 20px;
  font-size: 14px;
  flex-shrink: 0;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.alert svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.alert span {
  flex: 1 1;
}

.alert button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  opacity: 0.6;
  padding: 0;
  line-height: 1;
}

.alert button:hover {
  opacity: 1;
}

.alert-error {
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.2);
  color: #c0392b;
}

.alert-error svg {
  color: #e74c3c;
}

.alert-success {
  background: rgba(46, 204, 113, 0.1);
  border: 1px solid rgba(46, 204, 113, 0.2);
  color: #27ae60;
}

.alert-success svg {
  color: #2ecc71;
}

/* Form */
.editor-form {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 0;
}

.form-group {
  flex-shrink: 0;
}

.form-group-grow {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 200px;
}

.form-label {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.form-label-hint {
  font-size: 12px;
  font-weight: 400;
  color: var(--text-tertiary);
}

.form-input {
  width: 100%;
  padding: 14px 18px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  font-size: 15px;
  font-family: inherit;
  background: #fff;
  color: var(--text-primary);
  transition: all 0.2s ease;
}

.form-input::placeholder {
  color: var(--text-tertiary);
}

.form-input:hover {
  border-color: rgba(0, 0, 0, 0.2);
}

.form-input:focus {
  outline: none;
  border-color: var(--accent-orange);
  box-shadow: 0 0 0 4px rgba(255, 107, 74, 0.1);
}

.form-textarea {
  flex: 1 1;
  width: 100%;
  padding: 16px 18px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  font-size: 14px;
  font-family: 'Space Mono', monospace;
  line-height: 1.7;
  background: #fff;
  color: var(--text-primary);
  resize: none;
  transition: all 0.2s ease;
}

.form-textarea::placeholder {
  color: var(--text-tertiary);
  font-family: 'Space Mono', monospace;
}

.form-textarea:hover {
  border-color: rgba(0, 0, 0, 0.2);
}

.form-textarea:focus {
  outline: none;
  border-color: var(--accent-orange);
  box-shadow: 0 0 0 4px rgba(255, 107, 74, 0.1);
}

.form-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 10px;
  padding: 12px 14px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
}

.form-hint svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 1px;
  opacity: 0.6;
}

/* Stats */
.editor-stats {
  display: flex;
  gap: 24px;
  padding: 16px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.editor-stats .stat-value {
  font-size: 24px;
  font-weight: 700;
  font-family: 'Space Mono', monospace;
  color: var(--text-primary);
}

.editor-stats .stat-label {
  font-size: 12px;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Actions */
.editor-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.editor-actions-left,
.editor-actions-right {
  display: flex;
  gap: 12px;
}

.btn-primary,
.btn-secondary,
.btn-danger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.btn-primary {
  background: var(--accent-gradient);
  color: white;
  box-shadow: 0 4px 16px rgba(255, 107, 74, 0.25);
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 24px rgba(255, 107, 74, 0.35);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.btn-primary svg {
  width: 18px;
  height: 18px;
}

.btn-primary .btn-spinner {
  width: 18px;
  height: 18px;
  border-width: 2px;
  border-color: rgba(255, 255, 255, 0.3);
  border-top-color: white;
}

.btn-secondary {
  background: rgba(0, 0, 0, 0.04);
  color: var(--text-secondary);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.btn-secondary:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.08);
  color: var(--text-primary);
}

.btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-danger {
  background: rgba(231, 76, 60, 0.08);
  color: #c0392b;
  border: 1px solid rgba(231, 76, 60, 0.2);
}

.btn-danger svg {
  width: 16px;
  height: 16px;
}

.btn-danger:hover:not(:disabled) {
  background: rgba(231, 76, 60, 0.15);
  border-color: rgba(231, 76, 60, 0.3);
}

.btn-danger:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Super GEO Editor - Two Column Layout */
.geo-editor-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  flex: 1 1;
  min-height: 0;
}

.geo-editor-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}

.geo-editor-form .form-group-grow {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.geo-editor-form .form-group-grow .form-textarea {
  flex: 1 1;
  min-height: 200px;
  resize: none;
}

.geo-editor-form .editor-stats,
.geo-editor .editor-stats {
  border-top: none;
  padding-top: 16px;
  flex-shrink: 0;
}

.geo-editor-map {
  border-radius: 12px;
  overflow: hidden;
  min-height: 200px;
  margin-top: 21px; /* align with input (skip label) */
}

.geo-editor-map .proximity-map-container {
  width: 100%;
  height: 100% !important;
  border-radius: 12px;
}

.geo-editor-map .leaflet-container {
  width: 100%;
  height: 100%;
  border-radius: 12px;
}

.proximity-map-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px;
  text-align: center;
  color: var(--text-tertiary);
  gap: 12px;
}

.proximity-map-empty svg {
  width: 48px;
  height: 48px;
  color: #FF6B4A;
  opacity: 0.4;
}

.proximity-map-empty span {
  font-size: 14px;
}

/* Responsive */
@media (max-width: 1024px) {
  .url-lists-layout {
    grid-template-columns: 280px 1fr;
  }

  .url-lists-panel {
    padding: 20px;
  }

  .editor-content {
    padding: 24px;
  }
}

@media (max-width: 768px) {
  .url-lists-layout {
    grid-template-columns: 1fr;
  }

  .url-lists-panel {
    position: relative;
    height: auto;
    max-height: 50vh;
    border-right: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .url-editor-panel {
    min-height: 50vh;
  }

  .editor-empty {
    padding: 40px 24px;
  }

  .editor-content {
    padding: 20px;
  }

  .editor-header h2 {
    font-size: 20px;
  }

  .editor-actions {
    flex-direction: column;
    gap: 12px;
  }

  .editor-actions-left,
  .editor-actions-right {
    width: 100%;
    justify-content: stretch;
  }

  .editor-actions-right {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary,
  .btn-danger {
    width: 100%;
  }
}

/* Checkbox List for Multi-select */
.checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.checkbox-list-empty {
  color: var(--text-secondary);
  font-size: 13px;
  text-align: center;
  padding: 20px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1px solid transparent;
}

.checkbox-item:hover {
  border-color: rgba(255, 107, 74, 0.3);
  background: rgba(255, 107, 74, 0.03);
}

.checkbox-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #ff6b4a;
  cursor: pointer;
}

.checkbox-item .checkbox-label {
  font-size: 14px;
  color: var(--text-primary);
}

/* Form empty state */
.form-empty-state {
  color: var(--text-secondary);
  font-size: 13px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 10px;
  text-align: center;
}

/* =====================================================
   REMARKETING LISTS - Enhanced Form Design
   ===================================================== */

/* Two Column Grid Layout */
.remarketing-form-grid {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 32px;
  flex: 1 1;
  min-height: 0;
}

.remarketing-form-fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.remarketing-insights {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Duration Input Group */
.duration-input-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.duration-input {
  width: 80px !important;
  text-align: center;
  font-family: 'DM Sans', sans-serif;
  font-weight: 600;
}

.duration-suffix {
  color: var(--text-secondary);
  font-size: 14px;
}

.duration-presets {
  display: flex;
  gap: 6px;
  margin-left: auto;
}

.duration-preset {
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'DM Sans', sans-serif;
  color: var(--text-secondary);
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.duration-preset:hover {
  background: rgba(255, 107, 74, 0.08);
  border-color: rgba(255, 107, 74, 0.3);
  color: var(--accent-orange);
}

.duration-preset.active {
  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);
  border-color: transparent;
  color: white;
}

/* List Status Card - Redesigned */
.list-status-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}

.list-status-card.is-active {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(16, 185, 129, 0.02) 100%);
  border-color: rgba(16, 185, 129, 0.2);
}

.list-status-card.is-paused {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.08) 0%, rgba(245, 158, 11, 0.02) 100%);
  border-color: rgba(245, 158, 11, 0.2);
}

.status-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px 4px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.03em;
}

.is-active .status-badge {
  background: rgba(16, 185, 129, 0.15);
  color: #059669;
}

.is-paused .status-badge {
  background: rgba(245, 158, 11, 0.15);
  color: #d97706;
}

.status-pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: relative;
}

.is-active .status-pulse {
  background: #10b981;
}

.is-paused .status-pulse {
  background: #f59e0b;
}

.is-active .status-pulse::before {
  content: '';
  position: absolute;
  inset: -3px;
  border-radius: 50%;
  background: rgba(16, 185, 129, 0.4);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.5); opacity: 0; }
}

.status-label {
  line-height: 1;
}

.status-details {
  display: flex;
  align-items: center;
  gap: 16px;
}

.status-detail-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-secondary);
}

.status-detail-item svg {
  width: 14px;
  height: 14px;
  opacity: 0.6;
}

.status-detail-item.synced {
  color: #059669;
}

.status-detail-item.synced svg {
  opacity: 1;
}

/* Insight Cards */
.insight-card {
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.03) 0%, rgba(142, 58, 154, 0.03) 100%);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  padding: 20px;
}

.insight-card-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 16px;
}

.insight-card-header h3 {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
  margin: 0;
}

.insight-hint {
  font-size: 11px;
  color: var(--text-tertiary);
}

.insight-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  text-align: center;
  color: var(--text-tertiary);
  gap: 12px;
}

.insight-placeholder svg {
  width: 40px;
  height: 40px;
  opacity: 0.3;
}

.insight-placeholder span {
  font-size: 13px;
}

/* Capacity Gauge */
.capacity-gauge-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.capacity-gauge {
  position: relative;
  width: 260px;
  height: 140px;
}

.gauge-svg {
  width: 100%;
  height: 100%;
}

.gauge-center {
  position: absolute;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.gauge-value {
  display: block;
  font-size: 28px;
  font-weight: 700;
  font-family: 'DM Sans', sans-serif;
  color: var(--text-primary);
  line-height: 1;
}

.gauge-label {
  display: block;
  font-size: 11px;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 4px;
}

.capacity-meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 12px;
  width: 100%;
}

.capacity-level {
  display: flex;
  align-items: center;
  gap: 6px;
}

.level-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.level-text {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
}

.capacity-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-secondary);
}

.capacity-info svg {
  width: 14px;
  height: 14px;
  opacity: 0.6;
}

/* Real data metrics under gauge */
.capacity-real-data {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.real-data-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 70px;
}

.real-data-value {
  font-size: 18px;
  font-weight: 700;
  font-family: 'DM Sans', sans-serif;
  color: var(--text-primary);
}

.real-data-label {
  font-size: 11px;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

/* Form help text */
.form-help-text {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
}

.form-help-text svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--accent-orange);
}

/* Look-Alike Expansion */
.lookalike-expansion {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.lookalike-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.lookalike-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-purple) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.lookalike-icon svg {
  width: 18px;
  height: 18px;
  color: white;
}

.lookalike-title {
  flex: 1 1;
}

.lookalike-title h4 {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.lookalike-subtitle {
  font-size: 11px;
  color: var(--text-tertiary);
}

.lookalike-multiplier {
  padding: 6px 10px;
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(142, 58, 154, 0.1) 100%);
  border-radius: 8px;
}

.multiplier-value {
  font-size: 14px;
  font-weight: 700;
  font-family: 'DM Sans', sans-serif;
  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-purple) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.lookalike-bar-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lookalike-bar {
  display: flex;
  height: 28px;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.04);
}

.lookalike-bar-base {
  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  transition: width 0.4s ease-out;
}

.lookalike-bar-expansion {
  background: linear-gradient(135deg, rgba(142, 58, 154, 0.2) 0%, rgba(142, 58, 154, 0.4) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: width 0.4s ease-out;
}

.bar-label {
  font-size: 11px;
  font-weight: 600;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.lookalike-bar-expansion .bar-label {
  color: var(--accent-purple);
  text-shadow: none;
}

.lookalike-values {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  color: var(--text-secondary);
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
}

.lookalike-values svg {
  color: var(--text-tertiary);
}

.expanded-value {
  font-weight: 600;
  color: var(--accent-purple);
}

/* Insight Tips */
.insight-tips {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tip-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.4;
}

.tip-item svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #10b981;
  margin-top: 1px;
}

.tip-item svg[viewBox="0 0 24 24"]:not(:has(polyline)) {
  color: var(--accent-orange);
}

/* Responsive */
@media (max-width: 1100px) {
  .remarketing-form-grid {
    grid-template-columns: 1fr;
  }

  .remarketing-insights {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .insight-card {
    flex: 1 1;
    min-width: 280px;
  }

  .insight-tips {
    flex-direction: row;
    width: 100%;
  }

  .tip-item {
    flex: 1 1;
  }
}

/* ---------------------------------------------------------------------------
   Targeting templates page — the detail side.
   --------------------------------------------------------------------------- */
.tpl-rename-row { display: flex; gap: 10px; align-items: center; }
.tpl-rename-row input { flex: 1 1; min-width: 0; }

.tpl-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 14px;
}

.tpl-detail {
  padding: 12px 14px;
  border: 1px solid #edeff2;
  border-radius: 10px;
  background: #fff;
}

/* Lists that live inside one client's account, so the page can say in one line
   why they might not travel to another client of the same agency. */
.tpl-detail.client-bound { border-style: dashed; border-color: #ffd8a8; }

.tpl-detail-head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;
}

.tpl-detail-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #868e96;
}

.tpl-detail-count {
  font-size: 11.5px;
  color: #adb5bd;
}

.tpl-detail-items { display: flex; flex-wrap: wrap; gap: 6px; }

.tpl-chip {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 999px;
  background: #f1f3f5;
  color: #343a40;
  font-size: 12.5px;
  line-height: 1.4;
}

.tpl-hint {
  margin-top: 14px;
  font-size: 12.5px;
  line-height: 1.5;
  color: #868e96;
  max-width: 640px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/url-lists.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D,iBAAiB;;AAGjB,WAAW;AACX;EACE,aAAa;EACb,2CAA2C;EAC3C,MAAM;EACN,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;;;0BAI0B;AAC1B;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,+FAA+F;EAC/F,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,+FAA+F;EAC/F,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,sCAAsC;EACtC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;;AAGA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,+FAA+F;EAC/F,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oFAAoF;EACpF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,+FAA+F;AACjG;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,+FAA+F;EAC/F,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,uFAAuF;EACvF,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB,EAAE,kCAAkC;AACtD;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;EACb;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;0DAE0D;;AAE1D,2BAA2B;AAC3B;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,4BAA4B;EAC5B,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,oFAAoF;EACpF,yBAAyB;EACzB,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,+FAA+F;EAC/F,qCAAqC;AACvC;;AAEA;EACE,+FAA+F;EAC/F,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,WAAW,mBAAmB,EAAE,UAAU,EAAE;EAC5C,MAAM,qBAAqB,EAAE,UAAU,EAAE;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,+FAA+F;EAC/F,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uFAAuF;EACvF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,6FAA6F;EAC7F,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,uFAAuF;EACvF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,oFAAoF;EACpF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,6FAA6F;EAC7F,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;;gFAEgF;AAChF,kBAAkB,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACjE,wBAAwB,SAAO,EAAE,YAAY,EAAE;;AAE/C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;oEACoE;AACpE,2BAA2B,oBAAoB,EAAE,qBAAqB,EAAE;;AAExE;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;;AAE9D;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* URL Lists Page - Distinctive Design for Sense Platform */\n\n/* Import fonts */\n@import url('https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=DM+Sans:wght@400;500;600;700&display=swap');\n\n/* Layout */\n.url-lists-layout {\n  display: grid;\n  grid-template-columns: 340px minmax(0, 1fr);\n  gap: 0;\n  min-height: calc(100vh - 140px);\n  background: transparent;\n}\n\n/* A grid item defaults to min-width:auto, so it refuses to shrink below its\n   content and pushes the page wider than the screen instead. The research\n   dashboard lives in the right panel and is full of wide content — a 36px\n   title, a row of buttons, tables — so without this the whole page scrolls\n   sideways on a laptop. */\n.url-lists-layout > * {\n  min-width: 0;\n}\n\n/* Left Panel - Lists */\n.url-lists-panel {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-right: 1px solid rgba(0, 0, 0, 0.06);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  height: calc(100vh - 140px);\n  position: sticky;\n  top: 0;\n  overflow: hidden;\n}\n\n.panel-section {\n  flex-shrink: 0;\n}\n\n.panel-section .field-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n}\n\n.panel-section .field-select {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  background: #fff;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.panel-section .field-select:hover {\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.panel-section .field-select:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n/* Search */\n.search-wrapper {\n  position: relative;\n}\n\n.search-wrapper .search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 18px;\n  height: 18px;\n  color: var(--text-tertiary);\n  pointer-events: none;\n}\n\n.search-input {\n  width: 100%;\n  padding: 11px 14px 11px 42px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  background: #fff;\n  color: var(--text-primary);\n  transition: all 0.2s ease;\n}\n\n.search-input::placeholder {\n  color: var(--text-tertiary);\n}\n\n.search-input:hover {\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n/* Add Button */\n.add-list-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  padding: 14px 20px;\n  border: 2px dashed rgba(255, 107, 74, 0.4);\n  border-radius: 12px;\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.05) 0%, rgba(233, 75, 108, 0.05) 100%);\n  color: var(--accent-orange);\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  flex-shrink: 0;\n}\n\n.add-list-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n.add-list-btn:hover {\n  border-color: var(--accent-orange);\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.12) 0%, rgba(233, 75, 108, 0.08) 100%);\n  transform: translateY(-1px);\n}\n\n.add-list-btn:active {\n  transform: translateY(0);\n}\n\n/* Lists Container */\n.lists-container {\n  flex: 1;\n  overflow-y: auto;\n  margin: 0 -24px;\n  padding: 0 24px;\n}\n\n.lists-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.lists-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.lists-container::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n}\n\n.lists-container::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n/* Loading & Empty States */\n.lists-loading,\n.lists-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  color: var(--text-tertiary);\n  gap: 12px;\n}\n\n.lists-loading .spinner,\n.btn-spinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid rgba(255, 107, 74, 0.2);\n  border-top-color: var(--accent-orange);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.lists-empty svg {\n  width: 48px;\n  height: 48px;\n  opacity: 0.4;\n}\n\n\n/* List Item */\n.list-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  margin-bottom: 6px;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.02);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n}\n\n.list-item:hover {\n  background: rgba(255, 107, 74, 0.06);\n  border-color: rgba(255, 107, 74, 0.15);\n}\n\n.list-item.active {\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.12) 0%, rgba(233, 75, 108, 0.08) 100%);\n  border-color: rgba(255, 107, 74, 0.3);\n}\n\n.list-item-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.list-item-icon.keyword-icon {\n  background: linear-gradient(135deg, var(--accent-red) 0%, var(--accent-purple) 100%);\n}\n\n.editor-empty-icon.keyword-icon {\n  background: linear-gradient(135deg, rgba(233, 75, 108, 0.08) 0%, rgba(142, 58, 154, 0.08) 100%);\n}\n\n.editor-empty-icon.keyword-icon::before {\n  background: linear-gradient(135deg, var(--accent-red) 0%, var(--accent-purple) 100%);\n}\n\n.editor-empty-icon.keyword-icon svg {\n  color: var(--accent-purple);\n}\n\n.list-item-icon.geo-icon {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n}\n\n.editor-empty-icon.geo-icon {\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(5, 150, 105, 0.08) 100%);\n}\n\n.editor-empty-icon.geo-icon::before {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n}\n\n.editor-empty-icon.geo-icon svg {\n  color: #059669;\n}\n\n.list-item-icon svg {\n  width: 18px;\n  height: 18px;\n  color: white;\n}\n\n.list-item-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.list-item-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 2px;\n}\n\n.list-item-meta {\n  font-size: 12px;\n  color: var(--text-secondary);\n  font-family: 'Space Mono', monospace;\n}\n\n.list-item-arrow {\n  width: 18px;\n  height: 18px;\n  color: var(--text-tertiary);\n  flex-shrink: 0;\n  opacity: 0;\n  transform: translateX(-4px);\n  transition: all 0.2s ease;\n}\n\n.list-item:hover .list-item-arrow,\n.list-item.active .list-item-arrow {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.list-item.active .list-item-arrow {\n  color: var(--accent-orange);\n}\n\n/* Right Panel - Editor */\n.url-editor-panel {\n  background: rgba(255, 255, 255, 0.6);\n  backdrop-filter: blur(10px);\n  min-height: calc(100vh - 140px);\n  display: flex;\n  flex-direction: column;\n}\n\n/* Empty State */\n.editor-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 40px;\n  text-align: center;\n}\n\n.editor-empty-icon {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.08) 0%, rgba(142, 58, 154, 0.08) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 28px;\n  position: relative;\n}\n\n.editor-empty-icon::before {\n  content: '';\n  position: absolute;\n  inset: -4px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-purple) 100%);\n  opacity: 0.15;\n  z-index: -1;\n}\n\n.editor-empty-icon svg {\n  width: 48px;\n  height: 48px;\n  color: var(--accent-red);\n}\n\n.editor-empty h3 {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.editor-empty p {\n  font-size: 15px;\n  color: var(--text-secondary);\n  margin-bottom: 28px;\n  max-width: 320px;\n}\n\n.editor-empty-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 28px;\n  background: var(--accent-gradient);\n  color: white;\n  font-size: 15px;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 20px rgba(255, 107, 74, 0.3);\n}\n\n.editor-empty-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n.editor-empty-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 30px rgba(255, 107, 74, 0.4);\n}\n\n/* Editor Content */\n.editor-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 32px 40px;\n}\n\n.editor-content.geo-editor {\n  min-height: 0;\n}\n\n.editor-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  flex-shrink: 0;\n}\n\n.editor-header h2 {\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.editor-locked-badge {\n  font-size: 12px;\n  font-weight: 600;\n  color: #92400e;\n  background: #fef3c7;\n  border: 1px solid #fde68a;\n  padding: 4px 10px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n/* Alerts */\n.alert {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 18px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  flex-shrink: 0;\n  animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.alert svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.alert span {\n  flex: 1;\n}\n\n.alert button {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  opacity: 0.6;\n  padding: 0;\n  line-height: 1;\n}\n\n.alert button:hover {\n  opacity: 1;\n}\n\n.alert-error {\n  background: rgba(231, 76, 60, 0.1);\n  border: 1px solid rgba(231, 76, 60, 0.2);\n  color: #c0392b;\n}\n\n.alert-error svg {\n  color: #e74c3c;\n}\n\n.alert-success {\n  background: rgba(46, 204, 113, 0.1);\n  border: 1px solid rgba(46, 204, 113, 0.2);\n  color: #27ae60;\n}\n\n.alert-success svg {\n  color: #2ecc71;\n}\n\n/* Form */\n.editor-form {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-height: 0;\n}\n\n.form-group {\n  flex-shrink: 0;\n}\n\n.form-group-grow {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 200px;\n}\n\n.form-label {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.form-label-hint {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--text-tertiary);\n}\n\n.form-input {\n  width: 100%;\n  padding: 14px 18px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n  font-size: 15px;\n  font-family: inherit;\n  background: #fff;\n  color: var(--text-primary);\n  transition: all 0.2s ease;\n}\n\n.form-input::placeholder {\n  color: var(--text-tertiary);\n}\n\n.form-input:hover {\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  box-shadow: 0 0 0 4px rgba(255, 107, 74, 0.1);\n}\n\n.form-textarea {\n  flex: 1;\n  width: 100%;\n  padding: 16px 18px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n  font-size: 14px;\n  font-family: 'Space Mono', monospace;\n  line-height: 1.7;\n  background: #fff;\n  color: var(--text-primary);\n  resize: none;\n  transition: all 0.2s ease;\n}\n\n.form-textarea::placeholder {\n  color: var(--text-tertiary);\n  font-family: 'Space Mono', monospace;\n}\n\n.form-textarea:hover {\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.form-textarea:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  box-shadow: 0 0 0 4px rgba(255, 107, 74, 0.1);\n}\n\n.form-hint {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 10px;\n  padding: 12px 14px;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 10px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.form-hint svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  margin-top: 1px;\n  opacity: 0.6;\n}\n\n/* Stats */\n.editor-stats {\n  display: flex;\n  gap: 24px;\n  padding: 16px 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n  flex-shrink: 0;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.editor-stats .stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  font-family: 'Space Mono', monospace;\n  color: var(--text-primary);\n}\n\n.editor-stats .stat-label {\n  font-size: 12px;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Actions */\n.editor-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 20px;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n  flex-shrink: 0;\n}\n\n.editor-actions-left,\n.editor-actions-right {\n  display: flex;\n  gap: 12px;\n}\n\n.btn-primary,\n.btn-secondary,\n.btn-danger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 24px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.btn-primary {\n  background: var(--accent-gradient);\n  color: white;\n  box-shadow: 0 4px 16px rgba(255, 107, 74, 0.25);\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 24px rgba(255, 107, 74, 0.35);\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-primary svg {\n  width: 18px;\n  height: 18px;\n}\n\n.btn-primary .btn-spinner {\n  width: 18px;\n  height: 18px;\n  border-width: 2px;\n  border-color: rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n}\n\n.btn-secondary {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--text-secondary);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.08);\n  color: var(--text-primary);\n}\n\n.btn-secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-danger {\n  background: rgba(231, 76, 60, 0.08);\n  color: #c0392b;\n  border: 1px solid rgba(231, 76, 60, 0.2);\n}\n\n.btn-danger svg {\n  width: 16px;\n  height: 16px;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: rgba(231, 76, 60, 0.15);\n  border-color: rgba(231, 76, 60, 0.3);\n}\n\n.btn-danger:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Super GEO Editor - Two Column Layout */\n.geo-editor-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  flex: 1;\n  min-height: 0;\n}\n\n.geo-editor-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-height: 0;\n}\n\n.geo-editor-form .form-group-grow {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.geo-editor-form .form-group-grow .form-textarea {\n  flex: 1;\n  min-height: 200px;\n  resize: none;\n}\n\n.geo-editor-form .editor-stats,\n.geo-editor .editor-stats {\n  border-top: none;\n  padding-top: 16px;\n  flex-shrink: 0;\n}\n\n.geo-editor-map {\n  border-radius: 12px;\n  overflow: hidden;\n  min-height: 200px;\n  margin-top: 21px; /* align with input (skip label) */\n}\n\n.geo-editor-map .proximity-map-container {\n  width: 100%;\n  height: 100% !important;\n  border-radius: 12px;\n}\n\n.geo-editor-map .leaflet-container {\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n}\n\n.proximity-map-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 40px;\n  text-align: center;\n  color: var(--text-tertiary);\n  gap: 12px;\n}\n\n.proximity-map-empty svg {\n  width: 48px;\n  height: 48px;\n  color: #FF6B4A;\n  opacity: 0.4;\n}\n\n.proximity-map-empty span {\n  font-size: 14px;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .url-lists-layout {\n    grid-template-columns: 280px 1fr;\n  }\n\n  .url-lists-panel {\n    padding: 20px;\n  }\n\n  .editor-content {\n    padding: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .url-lists-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .url-lists-panel {\n    position: relative;\n    height: auto;\n    max-height: 50vh;\n    border-right: none;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  }\n\n  .url-editor-panel {\n    min-height: 50vh;\n  }\n\n  .editor-empty {\n    padding: 40px 24px;\n  }\n\n  .editor-content {\n    padding: 20px;\n  }\n\n  .editor-header h2 {\n    font-size: 20px;\n  }\n\n  .editor-actions {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .editor-actions-left,\n  .editor-actions-right {\n    width: 100%;\n    justify-content: stretch;\n  }\n\n  .editor-actions-right {\n    flex-direction: column;\n  }\n\n  .btn-primary,\n  .btn-secondary,\n  .btn-danger {\n    width: 100%;\n  }\n}\n\n/* Checkbox List for Multi-select */\n.checkbox-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.checkbox-list-empty {\n  color: var(--text-secondary);\n  font-size: 13px;\n  text-align: center;\n  padding: 20px;\n}\n\n.checkbox-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background: white;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  border: 1px solid transparent;\n}\n\n.checkbox-item:hover {\n  border-color: rgba(255, 107, 74, 0.3);\n  background: rgba(255, 107, 74, 0.03);\n}\n\n.checkbox-item input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #ff6b4a;\n  cursor: pointer;\n}\n\n.checkbox-item .checkbox-label {\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n/* Form empty state */\n.form-empty-state {\n  color: var(--text-secondary);\n  font-size: 13px;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 10px;\n  text-align: center;\n}\n\n/* =====================================================\n   REMARKETING LISTS - Enhanced Form Design\n   ===================================================== */\n\n/* Two Column Grid Layout */\n.remarketing-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 340px;\n  gap: 32px;\n  flex: 1;\n  min-height: 0;\n}\n\n.remarketing-form-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.remarketing-insights {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Duration Input Group */\n.duration-input-group {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.duration-input {\n  width: 80px !important;\n  text-align: center;\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 600;\n}\n\n.duration-suffix {\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n.duration-presets {\n  display: flex;\n  gap: 6px;\n  margin-left: auto;\n}\n\n.duration-preset {\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: 'DM Sans', sans-serif;\n  color: var(--text-secondary);\n  background: rgba(0, 0, 0, 0.03);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.duration-preset:hover {\n  background: rgba(255, 107, 74, 0.08);\n  border-color: rgba(255, 107, 74, 0.3);\n  color: var(--accent-orange);\n}\n\n.duration-preset.active {\n  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);\n  border-color: transparent;\n  color: white;\n}\n\n/* List Status Card - Redesigned */\n.list-status-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  transition: all 0.2s ease;\n}\n\n.list-status-card.is-active {\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(16, 185, 129, 0.02) 100%);\n  border-color: rgba(16, 185, 129, 0.2);\n}\n\n.list-status-card.is-paused {\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.08) 0%, rgba(245, 158, 11, 0.02) 100%);\n  border-color: rgba(245, 158, 11, 0.2);\n}\n\n.status-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 12px 4px 8px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n}\n\n.is-active .status-badge {\n  background: rgba(16, 185, 129, 0.15);\n  color: #059669;\n}\n\n.is-paused .status-badge {\n  background: rgba(245, 158, 11, 0.15);\n  color: #d97706;\n}\n\n.status-pulse {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  position: relative;\n}\n\n.is-active .status-pulse {\n  background: #10b981;\n}\n\n.is-paused .status-pulse {\n  background: #f59e0b;\n}\n\n.is-active .status-pulse::before {\n  content: '';\n  position: absolute;\n  inset: -3px;\n  border-radius: 50%;\n  background: rgba(16, 185, 129, 0.4);\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.5); opacity: 0; }\n}\n\n.status-label {\n  line-height: 1;\n}\n\n.status-details {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.status-detail-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.status-detail-item svg {\n  width: 14px;\n  height: 14px;\n  opacity: 0.6;\n}\n\n.status-detail-item.synced {\n  color: #059669;\n}\n\n.status-detail-item.synced svg {\n  opacity: 1;\n}\n\n/* Insight Cards */\n.insight-card {\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.03) 0%, rgba(142, 58, 154, 0.03) 100%);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 16px;\n  padding: 20px;\n}\n\n.insight-card-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.insight-card-header h3 {\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.insight-hint {\n  font-size: 11px;\n  color: var(--text-tertiary);\n}\n\n.insight-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 20px;\n  text-align: center;\n  color: var(--text-tertiary);\n  gap: 12px;\n}\n\n.insight-placeholder svg {\n  width: 40px;\n  height: 40px;\n  opacity: 0.3;\n}\n\n.insight-placeholder span {\n  font-size: 13px;\n}\n\n/* Capacity Gauge */\n.capacity-gauge-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.capacity-gauge {\n  position: relative;\n  width: 260px;\n  height: 140px;\n}\n\n.gauge-svg {\n  width: 100%;\n  height: 100%;\n}\n\n.gauge-center {\n  position: absolute;\n  bottom: 32px;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n}\n\n.gauge-value {\n  display: block;\n  font-size: 28px;\n  font-weight: 700;\n  font-family: 'DM Sans', sans-serif;\n  color: var(--text-primary);\n  line-height: 1;\n}\n\n.gauge-label {\n  display: block;\n  font-size: 11px;\n  color: var(--text-tertiary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-top: 4px;\n}\n\n.capacity-meta {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 12px;\n  width: 100%;\n}\n\n.capacity-level {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.level-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.level-text {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.capacity-info {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.capacity-info svg {\n  width: 14px;\n  height: 14px;\n  opacity: 0.6;\n}\n\n/* Real data metrics under gauge */\n.capacity-real-data {\n  display: flex;\n  justify-content: center;\n  gap: 32px;\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.real-data-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  min-width: 70px;\n}\n\n.real-data-value {\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'DM Sans', sans-serif;\n  color: var(--text-primary);\n}\n\n.real-data-label {\n  font-size: 11px;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n/* Form help text */\n.form-help-text {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 12px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.form-help-text svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: var(--accent-orange);\n}\n\n/* Look-Alike Expansion */\n.lookalike-expansion {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.lookalike-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.lookalike-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-purple) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.lookalike-icon svg {\n  width: 18px;\n  height: 18px;\n  color: white;\n}\n\n.lookalike-title {\n  flex: 1;\n}\n\n.lookalike-title h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.lookalike-subtitle {\n  font-size: 11px;\n  color: var(--text-tertiary);\n}\n\n.lookalike-multiplier {\n  padding: 6px 10px;\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(142, 58, 154, 0.1) 100%);\n  border-radius: 8px;\n}\n\n.multiplier-value {\n  font-size: 14px;\n  font-weight: 700;\n  font-family: 'DM Sans', sans-serif;\n  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-purple) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.lookalike-bar-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lookalike-bar {\n  display: flex;\n  height: 28px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.lookalike-bar-base {\n  background: linear-gradient(135deg, var(--accent-orange) 0%, var(--accent-red) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 60px;\n  transition: width 0.4s ease-out;\n}\n\n.lookalike-bar-expansion {\n  background: linear-gradient(135deg, rgba(142, 58, 154, 0.2) 0%, rgba(142, 58, 154, 0.4) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: width 0.4s ease-out;\n}\n\n.bar-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.lookalike-bar-expansion .bar-label {\n  color: var(--accent-purple);\n  text-shadow: none;\n}\n\n.lookalike-values {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n  color: var(--text-secondary);\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 500;\n}\n\n.lookalike-values svg {\n  color: var(--text-tertiary);\n}\n\n.expanded-value {\n  font-weight: 600;\n  color: var(--accent-purple);\n}\n\n/* Insight Tips */\n.insight-tips {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.tip-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 14px;\n  background: rgba(0, 0, 0, 0.02);\n  border-radius: 10px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n.tip-item svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #10b981;\n  margin-top: 1px;\n}\n\n.tip-item svg[viewBox=\"0 0 24 24\"]:not(:has(polyline)) {\n  color: var(--accent-orange);\n}\n\n/* Responsive */\n@media (max-width: 1100px) {\n  .remarketing-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .remarketing-insights {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .insight-card {\n    flex: 1;\n    min-width: 280px;\n  }\n\n  .insight-tips {\n    flex-direction: row;\n    width: 100%;\n  }\n\n  .tip-item {\n    flex: 1;\n  }\n}\n\n/* ---------------------------------------------------------------------------\n   Targeting templates page — the detail side.\n   --------------------------------------------------------------------------- */\n.tpl-rename-row { display: flex; gap: 10px; align-items: center; }\n.tpl-rename-row input { flex: 1; min-width: 0; }\n\n.tpl-details {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.tpl-detail {\n  padding: 12px 14px;\n  border: 1px solid #edeff2;\n  border-radius: 10px;\n  background: #fff;\n}\n\n/* Lists that live inside one client's account, so the page can say in one line\n   why they might not travel to another client of the same agency. */\n.tpl-detail.client-bound { border-style: dashed; border-color: #ffd8a8; }\n\n.tpl-detail-head {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.tpl-detail-label {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #868e96;\n}\n\n.tpl-detail-count {\n  font-size: 11.5px;\n  color: #adb5bd;\n}\n\n.tpl-detail-items { display: flex; flex-wrap: wrap; gap: 6px; }\n\n.tpl-chip {\n  display: inline-block;\n  padding: 3px 9px;\n  border-radius: 999px;\n  background: #f1f3f5;\n  color: #343a40;\n  font-size: 12.5px;\n  line-height: 1.4;\n}\n\n.tpl-hint {\n  margin-top: 14px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: #868e96;\n  max-width: 640px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
